export default "__VITE_ASSET__Dt2juROD__"